export default (that) => [
  {
    text: that.$l('table_label_detailDict') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
    allow: '',
    status: [],
    divided: false,
  },
  {
    text: that.$l('table_label_editDict') || '编辑字典',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
    status: ['Y'],
    divided: true,
  },
  {
    text: that.$l('table_label_deleteDict') || '删除字典',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    status: ['Y'],
    divided: false,
  }
]
